import { ServerRoutesService } from './../../services/server-routes.service';
import { RoutesApiResponse } from './../../models/route-api-response.model';
import { ServerRoute } from './../../models/server-route.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role } from '../../models/role.model';


@Component({
  selector: 'app-admin-roles-detail',
  templateUrl: './admin-roles-detail.component.html',
  styleUrls: ['./admin-roles-detail.component.scss']
})
export class AdminRolesDetailComponent implements OnInit {
  role: Role;
  routesResp: RoutesApiResponse;
  constructor( public dialogRef: MatDialogRef<AdminRolesDetailComponent>,
    private routesService: ServerRoutesService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.role = this.data.roleInfo;
    this.routesService.getRoutes().subscribe(data => this.setupRoutes(data));
  }

  setupRoutes(routesResp: RoutesApiResponse) {
    for (const route of routesResp.routes) {
      for (const roleRoutes of this.role.routes) {
        if (route.routeName === roleRoutes.routeName) {
          route.checked = true;
        }
      }
    }
    this.routesResp = routesResp;
  }

  close() {
    this.dialogRef.close();
  }

  saveChanges() {
    const activeRoutes = this.routesResp.routes.filter(q => q.checked === true).map(p => p.routeId);
    this.routesService.saveRoutes(this.role.roleName, activeRoutes).subscribe(data => this.close());
  }
}
